var e = {
    base: "base-input",
    search: "search-input",
    twice: "twice-input",
    multiSelect: "multiselect-input",
    copy: "copy-button",
    selectComponent: "select-component",
    card: "input-card",
    variable: "variable-textarea",
    variableIcon: "variable-icon"
  },
  t = {
    wrapper: "input__wrapper",
    search: "icon--search"
  },
  a = {
    dataAttributes: e,
    classNames: t
  };
export { a as inputSelectors };